import { createReducer, on } from '@ngrx/store';
import * as fromCardPaymentRedirect from '../actions/card.payment.redirect.action';
import { StateSlice } from '@core/helpers/state-slice';
import {
  CardPaymentRedirectRequest,
  CardPaymentRedirectResponse,
} from '@dgx-pr-spa/shared/util';

export interface CardPaymentRedirect {
  request: CardPaymentRedirectRequest;
  response: CardPaymentRedirectResponse;
}

export type CardPaymentRedirectState = StateSlice<CardPaymentRedirect>;

export const initialState: CardPaymentRedirectState = {
  data: {} as {
    request: CardPaymentRedirectRequest;
    response: CardPaymentRedirectResponse;
    addressChanged: boolean;
  },
  loaded: false,
  loading: false,
  error: null,
};

const cardPaymentRedirectReducer = createReducer(
  initialState,
  on(fromCardPaymentRedirect.loadCardPaymentRedirect, () => ({
    ...initialState,
    loading: true,
    loaded: false,
  })),
  on(
    fromCardPaymentRedirect.loadCardPaymentRedirectSuccess,
    (state, { payload }) => {
      return {
        ...state,
        data: payload,
        loading: false,
        loaded: true,
      };
    }
  ),
  on(fromCardPaymentRedirect.loadCardPaymentRedirectFail, (_, { payload }) => {
    return {
      ...initialState,
      error: payload,
    };
  }),
  on(fromCardPaymentRedirect.clearPaymentRedirect, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: CardPaymentRedirectState | undefined,
  action: fromCardPaymentRedirect.CardPaymentRedirectActions
) {
  return cardPaymentRedirectReducer(state, action);
}
